import axios from 'axios'
import Big from 'big.js'
import { config } from '../config'
import { NETWORK_VERSION } from '../hooks/useWeb3'
import { amountToWei } from '../utils/amount'

const cmsApi = axios.create({
  baseURL: process.env.REACT_APP_URL_CRM,
})

const bscscanApi = axios.create({
  baseURL: config.baseBscscanApiUrl,
})

const getGasFeesPolygon = async () => {
  let maxFeePerGas = new Big(40000000000) // fallback to 40 gwei
  let maxPriorityFeePerGas = new Big(40000000000) // fallback to 40 gwei
  try {
    const { data } = await axios({
      method: 'get',
      url:
        NETWORK_VERSION !== 137
          ? 'https://gasstation-mainnet.matic.network/v2'
          : 'https://gasstation-mumbai.matic.today/v2',
    })

    maxFeePerGas = amountToWei(new Big(Math.ceil(data.fast.maxFee)), 10)
    maxPriorityFeePerGas = amountToWei(Math.ceil(data.fast.maxPriorityFee), 10)

    return { maxFeePerGas, maxPriorityFeePerGas }
  } catch {
    console.error('failed to get gas estimation, using defaults ')
    return { maxFeePerGas, maxPriorityFeePerGas }
  }
}

export { cmsApi, bscscanApi, getGasFeesPolygon }
